import { useCallback, useMemo } from 'react';

import { MissionKindEnum, SubMissionActorCaseEnum } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { filterMissionWorkflowsOfKind } from '../utils/mission-workflows-of-kind.util';

import { useMissionWorkflowFamily } from './useMissionWorkflowFamily.hook';

// The quotation case of a sub-mission is the one of its workflow, each case
// having its workflow in the family of the mission.
export const useSubMissionQuotationCase = (workflowId: Id) => {
  const { familyMissionWorkflows } = useMissionWorkflowFamily(workflowId);
  const subMissionWorkflows = useMemo(
    () =>
      filterMissionWorkflowsOfKind(
        familyMissionWorkflows,
        MissionKindEnum.SubMission,
      ),
    [familyMissionWorkflows],
  );

  const quotationCase =
    subMissionWorkflows.find((workflow) => workflow._id === workflowId)
      ?.settings.subMissionActorCase ??
    SubMissionActorCaseEnum.SameEmitterAndReceiver;

  const workflowIdOfCase = useCallback(
    (subMissionActorCase: SubMissionActorCaseEnum) =>
      subMissionWorkflows.find(
        (workflow) =>
          workflow.settings.subMissionActorCase === subMissionActorCase,
      )?._id,
    [subMissionWorkflows],
  );

  return { quotationCase, workflowIdOfCase };
};
